'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../../node_modules/@material-ui/core/styles/makeStyles.js');
var KeyboardArrowRight = require('../../../IconsAndImages/Icons/KeyboardArrowRight.js');
var Breadcrumbs$1 = require('../../../node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles(function () {
  return {
    separator: {
      margin: 0
    }
  };
});
var Breadcrumbs = React.forwardRef(function (props, ref) {
  var _useStyles = useStyles(),
      separator = _useStyles.separator;

  props.dense;
      var otherProps = objectWithoutProperties(props, ["dense"]);

  return React__default["default"].createElement(Breadcrumbs$1["default"], _objectSpread({}, otherProps, {
    ref: ref,
    classes: {
      separator: props.dense ? separator : ""
    }
  }), React__default["default"].Children.map(props.children, function (child, index) {
    if (index === React__default["default"].Children.count(props.children) - 1) {
      return React__default["default"].cloneElement(child, {
        isLastItem: true
      });
    } else {
      return child;
    }
  }));
});
Breadcrumbs.defaultProps = {
  dense: true,
  separator: React__default["default"].createElement(KeyboardArrowRight, {
    color: "secondary",
    height: 14,
    width: 14
  })
};

module.exports = Breadcrumbs;
